import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=b8b732f6&scoped=true&"
import script from "./CommentModal.vue?vue&type=script&lang=js&"
export * from "./CommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b732f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b732f6')) {
      api.createRecord('b8b732f6', component.options)
    } else {
      api.reload('b8b732f6', component.options)
    }
    module.hot.accept("./CommentModal.vue?vue&type=template&id=b8b732f6&scoped=true&", function () {
      api.rerender('b8b732f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/CommentModal.vue"
export default component.exports